import { IExportCalculatorSettings, IExportPayout } from 'types';
import { appConfig } from '../config/app';
import { ApiClient, IApiQueryOptions } from './ApiClient';

export const DataExport = {
  sitePayouts: (siteId: string, options?: IApiQueryOptions) => ApiClient.get<IExportPayout[]>(`${appConfig.API_BASE_URL}/v1/export/sites/${siteId}/payouts`, options),
  siteCalculatorSettings: (siteId: string) => ApiClient.get<IExportCalculatorSettings>(`${appConfig.API_BASE_URL}/v1/export/sites/${siteId}/calculator/settings`),
};
